import EPopupAccordion from '@/components/everridge/popup/EPopupAccordion';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FinanceAnalyticsByMonthsResponseDto } from '../../types/finances-dto';
import AnalyticsElement from './AnalyticsElement';
import AnalyticsCardSkeleton from './AnalyticsCardSkeleton';
import CurrencyValue from '../CurrencyValue';
import User_02_Icon from '@/components/icons/User_02_Icon';
import IdeaIcon from '@/components/icons/IdeaIcon';
import Coupon01IconSolid from '@/components/icons/Coupon01IconSolid';
import DropletIconSolid from '@/components/icons/DropletIconSolid';
import GlobeIconSolid from '@/components/icons/GlobeIconSolid';
import FireIconSolid from '@/components/icons/FireIconSolid';
import MoneySendCircleIcon from '@/components/icons/MoneySendCircleIcon';

type Props = {
    data?: FinanceAnalyticsByMonthsResponseDto;
    isLoading?: boolean;
    hiddenExpenseKeySet?: ReadonlySet<string>;
};

const AnalyticsExpenses: FC<Props> = ({ data, isLoading, hiddenExpenseKeySet }) => {
    const { t } = useTranslation();

    const isHidden = (key: string) =>
        hiddenExpenseKeySet?.has(key.toLowerCase()) ?? false;

    return (
        <div className="flex flex-col gap-4">
            {isLoading && (
                <>
                    {Array.from({ length: 7 }).map((_, index) => (
                        <AnalyticsCardSkeleton key={index} />
                    ))}
                </>
            )}
            {!isLoading && (
                <>
                    {/* <EPopupAccordion
                        icon={Coupon01IconSolid}
                        label={t('main.finances.components.analytics.components.expenses.vat')}
                        value={<CurrencyValue value={data?.vat} asset='other' />}
                        content={<AnalyticsElement values={data?.vatMonths} />}
                        iconClassName="size-8 shrink-0 flex items-center justify-center rounded-semi-xl bg-[#FF2B801A] fill-[#FF2B80] stroke-none"
                    /> */}
                    {!isHidden('commissions') && (
                        <EPopupAccordion
                            icon={User_02_Icon}
                            label={t(
                                'main.finances.components.analytics.components.expenses.commissions',
                            )}
                            value={<CurrencyValue value={data?.commissions} asset="other" />}
                            content={<AnalyticsElement values={data?.commissionsMonths} />}
                            iconClassName="size-8 shrink-0 flex items-center justify-center rounded-semi-xl bg-[#D43FBB1A] fill-[#D43FBB] stroke-[#D43FBB]"
                        />
                    )}
                    {!isHidden('incomeTax') && (
                        <EPopupAccordion
                            icon={Coupon01IconSolid}
                            label={t(
                                'main.finances.components.analytics.components.expenses.incomeTax',
                            )}
                            value={<CurrencyValue value={data?.incomeTax} asset="other" />}
                            content={<AnalyticsElement values={data?.incomeTaxMonths} />}
                            iconClassName="size-8 shrink-0 flex items-center justify-center rounded-semi-xl bg-[#9B1CE01A] fill-[#9B1CE0] stroke-none"
                        />
                    )}
                    {!isHidden('internet') && (
                        <EPopupAccordion
                            icon={GlobeIconSolid}
                            label={t(
                                'main.finances.components.analytics.components.expenses.internet',
                            )}
                            value={<CurrencyValue value={data?.internet} asset="other" />}
                            content={<AnalyticsElement values={data?.internetMonths} />}
                            iconClassName="size-8 shrink-0 flex items-center justify-center rounded-semi-xl bg-[#565DCF1A] fill-[#565DCF] stroke-none"
                        />
                    )}
                    {!isHidden('water') && (
                        <EPopupAccordion
                            icon={DropletIconSolid}
                            label={t('main.finances.components.analytics.components.expenses.water')}
                            value={<CurrencyValue value={data?.water} asset="other" />}
                            content={<AnalyticsElement values={data?.waterMonths} />}
                            iconClassName="size-8 shrink-0 flex items-center justify-center rounded-semi-xl bg-[#2EB5661A] fill-[#2EB566] stroke-none"
                        />
                    )}
                    {!isHidden('electricity') && (
                        <EPopupAccordion
                            icon={IdeaIcon}
                            label={t(
                                'main.finances.components.analytics.components.expenses.electricity',
                            )}
                            value={<CurrencyValue value={data?.electricity} asset="other" />}
                            content={<AnalyticsElement values={data?.electricityMonths} />}
                            iconClassName="size-8 shrink-0 flex items-center justify-center rounded-semi-xl bg-[#E6A82A1A] stroke-[#E6A82A] fill-none"
                        />
                    )}
                    {!isHidden('gas') && (
                        <EPopupAccordion
                            icon={FireIconSolid}
                            label={t('main.finances.components.analytics.components.expenses.gas')}
                            value={<CurrencyValue value={data?.gas} asset="other" />}
                            content={<AnalyticsElement values={data?.gasMonths} />}
                            iconClassName="size-8 shrink-0 flex items-center justify-center rounded-semi-xl bg-[#E6782A1A] fill-[#E6782A] stroke-none"
                        />
                    )}
                    {!isHidden('previousMonthUtilities') && (
                        <EPopupAccordion
                            icon={MoneySendCircleIcon}
                            label={t(
                                'main.finances.components.analytics.components.expenses.previousMonthUtilities',
                            )}
                            value={
                                <CurrencyValue value={data?.previousMonthUtilities} asset="other" />
                            }
                            content={
                                <AnalyticsElement values={data?.previousMonthUtilitiesMonths} />
                            }
                            iconClassName="size-8 shrink-0 flex items-center justify-center rounded-semi-xl bg-[#2EC8F21A] stroke-[#2EC8F2]"
                        />
                    )}
                </>
            )}
        </div>
    );
};

export default AnalyticsExpenses;
